'use strict'

import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .controller('pageProtectionSettingsCtrl', [
    '$rootScope',
    '$scope',
    'SETTINGS_STATES',
    'BAS_INPUT_MODAL',
    'BAS_CURRENT_CORE',
    'PAGE_PROTECTION',
    'CurrentBasCore',
    'BasInputModal',
    'BasUtilities',
    pageProtectionSettingsController
  ])

/**
 * @param $rootScope
 * @param $scope
 * @param SETTINGS_STATES
 * @param BAS_INPUT_MODAL
 * @param BAS_CURRENT_CORE
 * @param PAGE_PROTECTION
 * @param {CurrentBasCore} CurrentBasCore
 * @param {BasInputModal} BasInputModal
 * @param {BasUtilities} BasUtilities
 */
function pageProtectionSettingsController (
  $rootScope,
  $scope,
  SETTINGS_STATES,
  BAS_INPUT_MODAL,
  BAS_CURRENT_CORE,
  PAGE_PROTECTION,
  CurrentBasCore,
  BasInputModal,
  BasUtilities
) {
  const pageProtection = this

  /**
   * @type {TCurrentBasCoreState}
   */
  pageProtection.currentBasCoreState = CurrentBasCore.get()
  pageProtection.SETTINGS_STATES = SETTINGS_STATES

  pageProtection.pin = ''
  pageProtection.pages = {
    [PAGE_PROTECTION.PREFIX_PAGE + PAGE_PROTECTION.P_DOORS]: false,
    [PAGE_PROTECTION.PREFIX_PAGE + PAGE_PROTECTION.P_SCENES]: false,
    [PAGE_PROTECTION.PREFIX_PAGE + PAGE_PROTECTION.P_SETTINGS]: false
  }

  pageProtection.pageTranslations = {
    [PAGE_PROTECTION.PREFIX_PAGE + PAGE_PROTECTION.P_DOORS]: 'doors',
    [PAGE_PROTECTION.PREFIX_PAGE + PAGE_PROTECTION.P_SCENES]: 'scenes',
    [PAGE_PROTECTION.PREFIX_PAGE + PAGE_PROTECTION.P_SETTINGS]: 'settings'
  }

  pageProtection.editPIN = async () => {
    const modal = await BasInputModal.show(
      BAS_INPUT_MODAL.T_CODE_INPUT,
      {
        title: BasUtilities.translate('edit_pin'),
        length: 4,
        obfuscate: false
      }
    )
    const result = await modal.closed

    if (result) {
      pageProtection.pin = result
      updateSharedServerStorage()
      $scope.$applyAsync()
    }
  }
  pageProtection.togglePage = (page) => {
    pageProtection.pages[page] = !pageProtection.pages[page]

    updateSharedServerStorage()
  }

  const updateSharedServerStorage = () => {

    CurrentBasCore.get().core?.core?.sharedServerStorage.updatePageProtection({
      pin: pageProtection.pin,
      pages: pageProtection.pages
    })
  }
  const syncFromSharedServerStorage = () => {
    const sharedServerStoragePageProtection =
      CurrentBasCore.get().core?.core?.sharedServerStorage.pageProtection

    if (sharedServerStoragePageProtection) {
      pageProtection.pin = sharedServerStoragePageProtection.pin
      pageProtection.pages = {
        ...pageProtection.pages,
        ...sharedServerStoragePageProtection.pages
      }

      $scope.$applyAsync()
    }
  }

  // Init

  syncFromSharedServerStorage()

  const listeners = []

  listeners.push($rootScope.$on(
    BAS_CURRENT_CORE.EVT_CORE_PAGE_PROTECTION,
    syncFromSharedServerStorage
  ))

  $scope.$on('$destroy', () => {
    BasUtil.executeArray(listeners)
  })
}
